import { NgModule } from '@angular/core';
import { NmiPosPaymentComponent } from './components/nmi-pos-payment/nmi-pos-payment.component';
import { NmiPosDevicesComponent } from './components/nmi-pos-devices/nmi-pos-devices.component';

/**
 * Import this module to use <nmi-pos-payment> and <nmi-pos-devices> in a
 * template-based (NgModule) context.
 *
 * For standalone components, import NmiPosPaymentComponent or
 * NmiPosDevicesComponent directly from '@cmbsolutions/nmi-angular'.
 */
@NgModule({
  imports: [
    NmiPosPaymentComponent,
    NmiPosDevicesComponent,
  ],
  exports: [
    NmiPosPaymentComponent,
    NmiPosDevicesComponent,
  ],
})
export class NmiPosModule {}
